export const enum Tasks {
  startUp = '0',
  runUp = '1',
  idealLine = '2',
  cleanRide = '3'
}
